module.exports = __webpack_public_path__ + "static/marko-600.1a01617e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/marko-600.jpg
// module id = 198
// module chunks = 35783957827783 267625579013595